// Mirrors the skill-document server predicates: user-scoped skills/% rows plus repo-backed
// immutable/adminSkills/% rows. Both are user-scoped, not company-scoped.
const isSkillKnowledgePath = (path) => {
  const safePath = String(path || '');

  return safePath.startsWith('skills/') || safePath.startsWith('immutable/adminSkills/');
};

export default isSkillKnowledgePath;
